import { EActivityType } from '@constants';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';

import { Wrapper, LabelWrapper } from './ActivityTypeFilter.styles';

import { Icon } from '@/components/Icon';

type Props = {
  value?: EActivityType;
  onChange?: (value?: EActivityType) => void;
  disabled?: boolean;
};

const ACTIVITY_TYPE_OPTIONS = [
  EActivityType.VIDEO,
  EActivityType.PDF,
  EActivityType.DELIVERABLE,
  EActivityType.TEXT,
  EActivityType.QUIZ
];

export const ActivityTypeFilter: React.FC<Props> = ({ value, onChange, disabled = false }) => {
  const { t } = useTranslation('ProblemReportsTranslations');

  const options = ACTIVITY_TYPE_OPTIONS.map(type => ({
    label: t(type),
    value: type
  }));

  return (
    <Wrapper $hasValue={!!value}>
      <Select
        variant="borderless"
        allowClear
        value={value}
        options={options}
        onChange={onChange}
        onClear={() => onChange?.(undefined)}
        styles={{ popup: { root: { minWidth: 160 } } }}
        labelRender={() => (
          <LabelWrapper>
            <span>{value ? t(value) : t('TYPE')}</span>
          </LabelWrapper>
        )}
        suffixIcon={<Icon i="CaretDown" />}
        placeholder={t('TYPE')}
        disabled={disabled}
      />
    </Wrapper>
  );
};
